import * as Sentry from "@sentry/tanstackstart-react";
import { useLayoutEffect } from "react";

type SentryUser = {
  id: string;
  email: string;
  name: string;
};

export function useSetSentryContext(
  user?: SentryUser | null
) {
  useLayoutEffect(() => {
    if (user) {
      Sentry.setUser({
        id: user.id,
        email: user.email,
        username: user.name,
      });
    } else {
      Sentry.setUser(null);
    }
  }, [user]);
}
